import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { AuthProvider } from "./auth";
import { CallerStateProvider } from "./callerState";
import { ProgramPanelProvider } from "./programPanel";
import { router } from "./router";
import "./styles.css";

const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 60_000, retry: 1 } } });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <CallerStateProvider>
          <ProgramPanelProvider>
            <RouterProvider router={router} />
          </ProgramPanelProvider>
        </CallerStateProvider>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
